module.exports = __webpack_public_path__ + "img/courses_banner.955a22fc.webp";